/**
 * Created by slava on 4/12/17
 */

const ResolutionManager = function () {
    this.isRotated = false;

    const frameSize = this.getFrameSize();
    this.frameWidth = frameSize.width;
    this.frameHeight = frameSize.height;
    this.scale = 1;
    this.viewportRect = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    };

    this.shown = false;
    this.containerPadding = cc.padding();
    this.paddings = {};
    this._calculatedSafePadding = cc.padding();
    this.mode = cleverapps.WideMode.VERTICAL;

    this.addSafePadding("platform", connector.platform.getSafePadding(), true);

    cc.view.adjustViewPort(true);

    this.updateDPR();

    let counter = 0;
    let timeoutHandler = undefined;
    const timeouts = [50, 100, 200, 300, 500, 1000, 2000, 4000];

    this.checkResize = cleverapps.accumulate(connector.platform.oneOf(connector.VK, connector.OKBRIDGE) ? ResolutionManager.RESIZE_THROTTLE_VK : ResolutionManager.RESIZE_THROTTLE, () => {
        this.addSafePadding("platform", connector.platform.getSafePadding(), true);
        this.addSafePadding("banner", cleverapps.bannerAd && cleverapps.bannerAd.getSafePadding(), true);

        const size = this.getFrameSize();
        if (size.width !== this.frameWidth || size.height !== this.frameHeight || !cc.paddingsEqual(this._calculateSafePadding(), this._calculatedSafePadding)) {
            console.log(`update resolution - ${JSON.stringify(size)}`);
            this.setupDesignResolution();
        }
    });

    const scheduleCheck = function () {
        if (counter === timeouts.length) {
            timeoutHandler = undefined;
            return;
        }

        if (timeoutHandler) {
            cleverapps.timeouts.clearTimeout(timeoutHandler);
        }

        timeoutHandler = cleverapps.timeouts.setTimeout(() => {
            this.checkResize();

            counter++;
            scheduleCheck();
        }, timeouts[counter]);
    }.bind(this);

    const resizeHandler = function () {
        this.checkResize();

        counter = 0;
        scheduleCheck();
    }.bind(this);

    if (connector.platform.oneOf(connector.WECHAT)) {
        const style = document.createElement("style");
        style.innerHTML = ".rotate-container {\n"
            + "    transform: rotate(-90deg);\n"
            + "    -webkit-transform: rotate(-90deg);\n"
            + "    transform-origin: 0px 0px 0px;\n"
            + "    -webkit-transform-origin: 0px 0px 0px;\n"
            + "}";
        document.head.appendChild(style);
    }

    window.addEventListener("resize", resizeHandler, false);
    window.addEventListener("orientationchange", resizeHandler, false);
    connector.platform.on("updateSafePadding", resizeHandler);
    connector.platform.on("updateFrameSize", resizeHandler);
    connector.payments.on("updateFrameSize", resizeHandler);
    connector.ads.on("updateFrameSize", resizeHandler);

    if (connector.platform.oneOf(connector.WECHAT)) {
        wx.onDeviceOrientationChange(resizeHandler);

        wx.onWindowResize(resizeHandler);
    }

    let count = 0;
    const checkSafeAreaInterval = cleverapps.timeouts.setInterval(() => {
        this.checkResize();

        count++;

        if (count >= 60) {
            cleverapps.timeouts.clearInterval(checkSafeAreaInterval);
        }
    }, 1000);

    if (cleverapps.config.debugMode) {
        cleverapps.flags.on("change:showSafeArea", this.updateSafeAreaDebugRect.bind(this));
    }
};

ResolutionManager.prototype.updateDPR = function () {
    const maxDPR = [connector.OS_WINDOWS, connector.OS_LINUX].includes(connector.info.os) ? 2 : 3;

    this.devicePixelRatio = Math.min(maxDPR, window.devicePixelRatio || 1);

    cc.view._devicePixelRatio = this.devicePixelRatio;
};

ResolutionManager.prototype._calculateSafeAreaDefault = function () {
    if (!this.resolutionInitialized) {
        return cc.padding();
    }

    const container = this._calculateContainerRect();

    let padding = container.width < container.height * 1.1 ? cleverapps.styles.UI.SafeArea.Vertical : cleverapps.styles.UI.SafeArea.Horizontal;
    if (this._willRotateToPreferredOrientation()) {
        padding = cc.rotatePadding(padding);
    }
    padding = cc.multPadding(padding, container.height / cleverapps.styles.SCENE_HEIGHT);
    return padding;
};

ResolutionManager.prototype.whenResolutionInitialized = function (callback) {
    if (this.resolutionInitialized) {
        callback();
    } else {
        this.resolutionInitializedCallback = callback;
    }
};

ResolutionManager.prototype.showCanvas = function () {
    if (this.shown) {
        return;
    }
    this.shown = true;

    if (window.wechatFirstScreen) {
        window.wechatFirstScreen.end();
        delete window.wechatFirstScreen;

        const scene = cleverapps.Scenes.GetRunningScene();
        if (scene) {
            scene._canvas.active = true;
        }
    }

    if (cc.container) {
        const gameContainer = cc.container;
        gameContainer.style.display = "block";
    }

    const gameCanvas = cc.game.canvas;
    gameCanvas.style.display = "block";
    gameCanvas.style.left = null;
    gameCanvas.style.top = null;

    const cocosLoading = document.getElementById("cocosLoading");
    if (cocosLoading) {
        document.body.removeChild(cocosLoading);
    }

    gameCanvas.tabIndex = -1;
    gameCanvas.focus();

    this.setupDesignResolution();
};

ResolutionManager.prototype.isInitialized = function () {
    return this.resolutionName !== undefined;
};

ResolutionManager.prototype.setupResolutionScale = function () {
    if (connector.platform.oneOf(connector.GAMESNACK)) {
        cleverapps.styles.SCENE_MAX_WIDTH *= 1.5;
    }

    if (!this.resolutionName || !resolutions[this.resolutionName]) {
        this.resolutionName = this._calcResolution();
    }

    resolutionScale = resolutions[this.resolutionName].scale;

    cleverapps.UI.updateSizes(resolutionScale);

    this.setupDesignResolution();
};

ResolutionManager.prototype.addSafePadding = function (id, padding, silent) {
    this.paddings[id] = padding || cc.padding();
    
    if (!silent) {
        this.checkResize();
    }
};

ResolutionManager.prototype.removeSafePadding = function (id, silent) {
    delete this.paddings[id];

    if (!silent) {
        this.checkResize();
    }
};

ResolutionManager.prototype._calculateSafePadding = function () {
    let paddings;
    if (this.safePaddingDebug) {
        paddings = [this.safePaddingDebug];
    } else {
        paddings = Object.values(this.paddings);
        paddings.push(this._calculateSafeAreaDefault());
    }

    if (this._willRotateToPreferredOrientation()) {
        paddings = paddings.map(cc.rotatePadding);
    }

    return cc.mergePaddings(paddings);
};

if (cleverapps.config.debugMode) {
    ResolutionManager.prototype.setSafePaddingDebug = function (padding) {
        this.safePaddingDebug = padding;

        this.setupDesignResolution();
    };

    ResolutionManager.prototype.updateSafeAreaDebugRect = function () {
        if (this.safeAreaDebugRect) {
            this.safeAreaDebugRect.removeFromParent();
        }

        if (cleverapps.flags.get("showSafeArea")) {
            const rect = cc.rect(
                this.sceneRect.x,
                this.sceneRect.y,
                this.sceneRect.width,
                this.sceneRect.height
            );

            this.safeAreaDebugRect = drawDebugRect(rect, cc.color(130, 0, 130, 255));
        } else if (this.safeAreaDebugRect) {
            this.safeAreaDebugRect.removeFromParent();
        }

        const safeAreaInsets = document.getElementById("safeAreaInsets");
        if (safeAreaInsets) {
            safeAreaInsets.style.display = cleverapps.flags.get("showSafeArea") ? "block" : "none";
        }
    };
}

ResolutionManager.prototype.setContainerPadding = function (padding) {
    padding = padding || {};
    this.containerPadding = cc.padding(padding);
    this.setupDesignResolution();
};

ResolutionManager.prototype.getFrameSize = function () {
    const size = connector.platform.getFrameSize();

    return this.isRotated ? cc.size(size.height, size.width) : size;
};

ResolutionManager.prototype.isLandscapeOrientation = function () {
    return window.innerHeight < window.innerWidth;
};

ResolutionManager.prototype.isPortraitOrientation = function () {
    return window.innerHeight > window.innerWidth;
};

ResolutionManager.prototype.resizeFont = function (font) {
    let coef = 1;
    if (this.mode === cleverapps.WideMode.VERTICAL) {
        coef = 25 / 40;
    } else if (this.mode === cleverapps.WideMode.SQUARE) {
        coef = 34 / 40;
    }

    return {
        name: font.name,
        size: coef * font.size,
        color: font.color,
        stroke: font.stroke
    };
};

ResolutionManager.prototype.getSceneSize = function () {
    return cc.size(this.sceneRect.width, this.sceneRect.height);
};

ResolutionManager.prototype.getBgSize = function () {
    return cc.size(this.bgSize);
};

ResolutionManager.prototype.getSafePadding = function () {
    return cc.padding(
        this.bgSize.height - this.sceneRect.y - this.sceneRect.height,
        this.bgSize.width - this.sceneRect.x - this.sceneRect.width,
        this.sceneRect.y,
        this.sceneRect.x
    );
};

ResolutionManager.prototype.getBgRect = function () {
    return cc.rect(-this.sceneRect.x, -this.sceneRect.y, this.bgSize.width, this.bgSize.height);
};

ResolutionManager.prototype.setupDesignResolution = function (customFrameSize) {
    if (!(connector.platform.oneOf(connector.WECHAT))) {
        if (this._willRotateToPreferredOrientation()) {
            cc.container.classList.add("rotate-container");
            this.isRotated = true;
        } else {
            cc.container.classList.remove("rotate-container");
            this.isRotated = false;
        }
    }

    const frameSize = customFrameSize || this.getFrameSize();
    this.frameWidth = Math.max(frameSize.width, cleverapps.MIN_FRAME_SIZE);
    this.frameHeight = Math.max(frameSize.height, cleverapps.MIN_FRAME_SIZE);
    this._calculatedSafePadding = this._calculateSafePadding();

    // OK triggers resize after return to our frame with values width = 1 (invalid value), height = 700, it breaks everything below
    // fotostrana request window width 300 height 700
    if (Math.min(this.frameWidth, this.frameHeight) < cleverapps.SETUP_RESOLUTION_MIN_FRAME_SIZE) {
        this.bgSize = this.bgSize || cc.size(this.frameWidth, this.frameHeight);
        this.sceneRect = this.sceneRect || cc.rect(0, 0, this.frameWidth, this.frameHeight);
        return;
    }

    this.updateDPR();
    this._updateSceneRect(customFrameSize !== undefined);
    this._updateEngine();

    this.mode = cleverapps.WideMode.VERTICAL;
    if (this.sceneRect.width > cleverapps.styles.SQUARE_MODE_WIDTH) {
        this.mode = cleverapps.WideMode.SQUARE;
    }
    if (this.sceneRect.width > cleverapps.styles.HORIZONTAL_MODE_WIDTH) {
        this.mode = cleverapps.WideMode.HORIZONTAL;
    }

    this.resizeScene();

    if (cleverapps.config.debugMode) {
        this.updateSafeAreaDebugRect();
    }

    this.resolutionInitialized = true;

    if (this.resolutionInitializedCallback) {
        this.resolutionInitializedCallback();
        this.resolutionInitializedCallback = undefined;
    }
};

ResolutionManager.prototype.resizeScene = function (withResize = true, withAfterResize = true) {
    if (cleverapps.bannerAd) {
        cleverapps.bannerAd.doResize();
    }

    const scene = cleverapps.Scenes.GetRunningScene();
    if (!scene) {
        return;
    }

    if (withResize) {
        cc.Base.PerformRecursiveFromLeaves(scene, (node) => {
            node.listRunningActions().forEach((action) => {
                if (action.canFinalize()) {
                    node.stopAction(action, true);
                }
            });
            
            const sceneComponent = ComponentMap.get(node, SceneComponent);
            if (sceneComponent || node instanceof CleverappsWindow) {
                if (node.notLoaded) {
                    if (sceneComponent) {
                        sceneComponent.onResizeWhileNotLoaded();
                    } else {
                        node.onResizeWhileNotLoaded();
                    }
                    return;
                }
            }

            ComponentMap.callHooks(node, "onResize");

            if (node.onResize) {
                node.onResize();
            }
        }, (node) => !node.notResizable);
    }

    if (withAfterResize) {
        cc.Base.PerformRecursiveFromLeaves(scene, (node) => {
            const sceneComponent = ComponentMap.get(node, SceneComponent);
            if (sceneComponent || node instanceof CleverappsWindow) {
                if (node.notLoaded) {
                    return;
                }
            }

            ComponentMap.callHooks(node, "onAfterResize");

            if (node.onAfterResize) {
                node.onAfterResize();
            }
        }, (node) => !node.notResizable);

        const movedUpNodes = [
            cleverapps.tutorial,
            cleverapps.availableMove
        ];

        movedUpNodes.forEach((model) => {
            if (model && model.onAfterResize) {
                model.onAfterResize();
            }
        });
    }
};

ResolutionManager.prototype.isVertical = function () {
    return this.mode === cleverapps.WideMode.VERTICAL;
};

ResolutionManager.prototype.isHorizontal = function () {
    return this.mode === cleverapps.WideMode.HORIZONTAL;
};

ResolutionManager.prototype._calculateContainerRect = function () {
    const padding = cc.padding(this.containerPadding);
    return this.isRotated ? cc.rect(
        padding.top,
        padding.left,
        this.frameWidth - padding.top - padding.bottom,
        this.frameHeight - padding.left - padding.right
    ) : cc.rect(
        padding.left,
        padding.top,
        this.frameWidth - padding.left - padding.right,
        this.frameHeight - padding.top - padding.bottom
    );
};

ResolutionManager.prototype._positionContainer = function (w, h, containerRect) {
    const padding = cc.padding(this.containerPadding);

    const devicePixelRatio = this.devicePixelRatio;

    cc.view._viewPortRect = cc.rect(0, 0, this.frameWidth * devicePixelRatio, this.frameHeight * devicePixelRatio);
    cc.view._visibleRect = cc.rect(0, 0, w, h);
    cc.winSize.width = cc.director._winSizeInPoints.width = w;
    cc.winSize.height = cc.director._winSizeInPoints.height = h;

    const scale = containerRect.height / h;
    cc.view._scaleX = cc.view._scaleY = devicePixelRatio * scale;
    this.scale = devicePixelRatio * scale;

    const containerW = w * scale;
    const containerH = containerRect.height;

    this.viewportRect = {
        x: 0,
        y: 0,
        width: containerW * devicePixelRatio,
        height: containerH * devicePixelRatio
    };

    if (connector.info.isInApp && connector.platform.oneOf(connector.INSTANT)) {
        document.body.style.width = "100vw";
        document.body.style.height = "100vh";
    }

    const contStyle = cc.game.container.style;
    // fractional css sizes, rounding up would push the container past the viewport
    contStyle.width = cc.game.canvas.style.width = `${containerW}px`;
    contStyle.height = cc.game.canvas.style.height = `${containerH}px`;
    contStyle.left = `${Math.round(padding.left)}px`;
    contStyle.top = `${Math.round(padding.top) + (this.isRotated ? containerRect.width : 0)}px`;
    contStyle.padding = `0 ${(containerRect.width - containerW) / 2}px`;

    cc.game.canvas.width = Math.round(containerW * devicePixelRatio);
    cc.game.canvas.height = Math.round(containerH * devicePixelRatio);
};

ResolutionManager.prototype._updateSceneRect = function (doNotLimit) {
    const containerRect = this._calculateContainerRect();

    const c = containerRect.width / containerRect.height;

    const heightBgScale = containerRect.height / (containerRect.height - this._calculatedSafePadding.bottom - this._calculatedSafePadding.top);
    const widthBgScale = containerRect.width / (containerRect.width - this._calculatedSafePadding.left - this._calculatedSafePadding.right);
    let h = cleverapps.styles.SCENE_HEIGHT * heightBgScale;
    let w = h * c;

    if (w < cleverapps.styles.SCENE_MIN_WIDTH && !doNotLimit) {
        w = cleverapps.styles.SCENE_MIN_WIDTH;
        h = w / c;
    }

    if (w > cleverapps.styles.SCENE_MAX_WIDTH && !doNotLimit) {
        w = cleverapps.styles.SCENE_MAX_WIDTH;
    }

    this._positionContainer(w, h, containerRect);

    w = 2 * Math.round(w / 2);
    h = 2 * Math.round(h / 2);

    this.bgSize = cc.size(w, h);

    let sceneHeight = h / heightBgScale;
    sceneHeight = 2 * Math.round(sceneHeight / 2);
    let sceneWidth = w / widthBgScale;
    sceneWidth = 2 * Math.round(sceneWidth / 2);

    const paddingScaleX = w / containerRect.width;
    const paddingScaleY = h / containerRect.height;

    const left = 2 * Math.round(this._calculatedSafePadding.left * paddingScaleX / 2);
    const bottom = 2 * Math.round(this._calculatedSafePadding.bottom * paddingScaleY / 2);

    this.sceneRect = cc.rect(left, bottom, sceneWidth, sceneHeight);
};

ResolutionManager.prototype._willRotateToPreferredOrientation = function () {
    if (connector.platform.oneOf(connector.WECHAT, connector.YOUTUBE, connector.ARKADIUM, connector.GDCOM)
        || (connector.platform.oneOf(connector.GAMESNACK) && ["merge", "merge2"].includes(cleverapps.config.type))
        || connector.info.isNative) {
        return false;
    }

    const isOrientationMismatch = window.innerWidth > window.innerHeight && cleverapps.config.orientation === "vertical"
        || window.innerWidth < window.innerHeight && cleverapps.config.orientation === "horizontal";

    const screenSize = window.screen || this.getFrameSize();
    const isTablet = Math.min(screenSize.width, screenSize.height) > Math.max(screenSize.width, screenSize.height) * 0.65;

    return connector.info.isMobile && !isTablet && isOrientationMismatch;
};

ResolutionManager.prototype._calcResolution = function () {
    let height = this.frameHeight;
    if (window.screen && window.screen.height) {
        height = Math.max(height, window.screen.height);
    }
    if (connector.platform.oneOf(connector.MOBAGE)) {
        height = MobageLogic.HEIGHT;
    }
    const pixelSizeHeight = height * this.devicePixelRatio;

    let names = Object.keys(resolutions);
    const webpNames = names.filter((name) => resolutions[name].webp);

    if (webpNames.length > 0) {
        if (cleverapps.config.webpSupport) {
            names = webpNames;
        } else if (webpNames.length < names.length) {
            names = cleverapps.substract(names, webpNames);
        }
    }

    names = names.sort((a, b) => resolutions[a].scale - resolutions[b].scale);

    const calcResValue = function (resolution) {
        const h = resolution.scale * cleverapps.styles.SCENE_HEIGHT;
        return h >= pixelSizeHeight ? (h - pixelSizeHeight) : ((pixelSizeHeight - h) * 100);
    };

    let bestId = 0;
    let bestDiff = calcResValue(resolutions[names[bestId]]);

    for (let i = 1; i < names.length; i++) {
        const diff = calcResValue(resolutions[names[i]]);

        if (diff < bestDiff) {
            bestDiff = diff;
            bestId = i;
        }
    }

    return names[bestId];
};

ResolutionManager.prototype._updateEngine = function () {
    if (engine === "creator") {
        creator.director.root.resizeRoot(cc.game.canvas.width, cc.game.canvas.height, 1);
        return;
    }

    if (cc._renderType === cc.game.RENDER_TYPE_WEBGL) {
        // reset director's member variables to fit visible rect
        cc.director.setGLDefaultValues();
    } else if (cc._renderType === cc.game.RENDER_TYPE_CANVAS) {
        cc.renderer._allNeedDraw = true;
    }
    cc._renderContext.resetCache && cc._renderContext.resetCache();

    cc.view._initFrameSize();
    if (connector.info.isMobile) {
        cc.view._adjustViewportMeta();
    }
};

cleverapps.WideMode = {
    VERTICAL: 0,
    SQUARE: 1,
    HORIZONTAL: 2
};

ResolutionManager.RESIZE_THROTTLE = 0;
ResolutionManager.RESIZE_THROTTLE_VK = 50;
